var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 97") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.781,104.122H99.219a2.111,2.111,0,0,0,2.111-2.111V52.188a2.11,2.11,0,0,0-.851-1.694L65.26,24.3a2.109,2.109,0,0,0-2.519,0l-35.219,26.2a2.11,2.11,0,0,0-.851,1.694v49.822A2.111,2.111,0,0,0,28.781,104.122ZM72.195,99.9H55.8V75.344H72.195Zm-41.3-46.651L64,28.62,97.108,53.249V99.9H76.417V73.233a2.111,2.111,0,0,0-2.111-2.111H53.69a2.111,2.111,0,0,0-2.111,2.111V99.9H30.892Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartSvgrepoCom);
export default __webpack_public_path__ + "static/media/cart-svgrepo-com.74673d275394a6c4a31327eaca063f95.svg";
export { ForwardRef as ReactComponent };